import React from 'react';
import useStyles from './styles';

function PaymentDetails(props) {
  const { formValues } = props;
  const classes = useStyles();
  const { plan } = formValues;

  const newPlan = JSON.parse(plan);

  const { users, connections, queues } = newPlan;
  const rows = [
    ['Usuários', users],
    ['Conexão', connections],
    ['Filas', queues],
    ['Cobrança', 'Mensal']
  ];
  return (
    <div className={classes.block}>
      <h4 className={classes.title}>Detalhes do plano</h4>
      <dl className={classes.rows}>
        {rows.map(([term, value]) => (
          <div className={classes.row} key={term}>
            <dt className={classes.term}>{term}</dt>
            <dd className={classes.value}>{value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}

export default PaymentDetails;
